import { ProvisionApi } from '@Apis';
import { Info } from '@Components/Common/Info';
import { Flex, TextLabel } from '@tonic-one/react';
import { getServiceNamesMapping, SERVICE_TYPES } from '@Utils/service';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ServiceNameEnum } from '../../../../../types';
import ServiceCheckbox from '../../../ServiceCheckbox';
import { useOneTimeReportStore } from '../../store';

import style from '@Report/OneTimeReports/index.module.less';

const ReportServices = () => {
  const { t } = useTranslation();
  const orgId = useOneTimeReportStore((store) => store.generalSetting.orgId);

  //getter
  const services = useOneTimeReportStore(
    (store) => store.generalSetting.services
  );

  //setter
  const setServices = useOneTimeReportStore((store) => store.setServices);

  //register
  const register = useOneTimeReportStore(
    (store) => store.registerResetCallback
  );
  const unregister = useOneTimeReportStore(
    (store) => store.unregisterResetCallback
  );
  useEffect(() => {
    if (!orgId) return;
    const cb = async () => {
      const ret = await getServices(orgId);
      setServices(ret);
    };
    cb();
    register(cb);
    return () => unregister(cb);
  }, [orgId]);

  return (
    <>
      <TextLabel className={style.itemLabel + ' required'}>
        {t('reportCommon.labels.services')}:
      </TextLabel>
      <Flex align="center" gap="8px">
        <ServiceCheckbox
          checkedServices={services}
          setCheckedServices={setServices}
        />
        <Info content={t('reportCommon.tips.hints.services')} />
      </Flex>
    </>
  );
};

const getServices = async (orgId: string) => {
  const provisionedServiceTypeList = (
    await ProvisionApi.getProvisionedServicesByOrgId(orgId)
  ).data;
  const provisionedServiceNames = getServiceNamesMapping(
    SERVICE_TYPES,
    provisionedServiceTypeList
  ).filter(
    //report don't need 'microsoft_identity_protection' and 'microsoft_information_protection',
    (s) =>
      ![
        ServiceNameEnum.MicrosoftIdentityProtection,
        ServiceNameEnum.MicrosoftInformationProtection,
      ].includes(s)
  );

  return provisionedServiceNames;
};

export default ReportServices;
